import { config } from "../../constants/constant";

export const aggregatorEndpoints = {
  DOCUMENT_TYPE_LIST: config.BASE_URI + "/api/v2/document_type",
  ADVANCE_SEARCH_ENDPOINT: config.BASE_URI + "/secure/api/v1/admin/approved_template_search"
};

export const DOWNLOAD_PARTNER_BRAND_REPORT = process.env.REACT_APP_BASE_URI + "/secure/api/v2/aggregator_download_excel_report_for_brands"